var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 17.625V0.375",
    stroke: "#F7CE00",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 14.625C1.83257 14.1658 3.34732 13.9134 4.875 13.875C7.125 13.875 10.5 15.375 12.75 15.375C14.2531 15.3038 15.7347 14.9887 17.1368 14.442C17.2802 14.3886 17.4039 14.2925 17.4911 14.1667C17.5784 14.041 17.6251 13.8916 17.625 13.7385V3.33C17.625 3.21085 17.5966 3.09341 17.5421 2.98742C17.4877 2.88143 17.4088 2.78993 17.3119 2.72051C17.2151 2.65109 17.1032 2.60573 16.9853 2.58821C16.8674 2.57069 16.7471 2.5815 16.6343 2.61975C15.3855 3.06785 14.0756 3.32254 12.75 3.375C10.5 3.375 7.125 1.875 4.875 1.875C3.34732 1.91341 1.83257 2.16587 0.375 2.625V14.625Z",
    stroke: "#F7CE00",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 10.125V5.625",
    stroke: "#F7CE00",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37875 11.625H9.375",
    stroke: "#F7CE00",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 12C9.27143 12 9.1875 11.9161 9.1875 11.8125C9.1875 11.7089 9.27143 11.625 9.375 11.625",
    stroke: "#F7CE00",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 12C9.47857 12 9.5625 11.9161 9.5625 11.8125C9.5625 11.7089 9.47857 11.625 9.375 11.625",
    stroke: "#F7CE00",
    strokeWidth: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFlag);
export default __webpack_public_path__ + "static/media/warning-flag.3185c36ce48a428d8a5b3f2317156998.svg";
export { ForwardRef as ReactComponent };